import { produce } from 'immer';
import {
  LOGIN_REQUEST_SUCCESS,
  LOGOUT_REQUEST_SUCCESS,
  LOGIN_REQUEST_FAIL,
  PASSWORD_RESET_FAIL,
  PASSWORD_RESET_SUCCESS,
  FORGOT_PASSWORD_FAIL,
  CLEAR_ERROR,
} from 'store/constants/action-types';

const initialState = {
  isLoggedIn: false,
  hasError: false,
  messages: [],
  redirect: false,
  errorMessage: '',
};

export const loginReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case LOGIN_REQUEST_SUCCESS:
      case LOGOUT_REQUEST_SUCCESS:
      case LOGIN_REQUEST_FAIL:
      case PASSWORD_RESET_FAIL:
        return action.payload;
      case PASSWORD_RESET_SUCCESS:
      case FORGOT_PASSWORD_FAIL:
        draft.redirect = action.payload.redirect;
        draft.errorMessage = Array.isArray(action.payload.errorMessage)
          ? action.payload.errorMessage[0]
          : action.payload.errorMessage;
        draft.hasError = action.payload.hasError;
        break;
      case CLEAR_ERROR:
        draft.hasError = false;
        break;
      default:
        return state;
    }
  });

export default loginReducer;
